import axiosInstance from "../services/AxiosInstance"

const API_URL = "/batchoverrides"

export const getBatchOverrides = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let url = `${API_URL}?limit=${limit}&page=${page}`;

    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
      if (searchField && searchField !== "all") {
        url += `&searchField=${searchField}`;
      }
    }

    const response = await axiosInstance.get(url);
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    };
  } catch (error) {
    console.error("Error fetching batch overrides", error);
    throw error;
  }
};

export const createBatchOverride = async (overrideData) => {
  try {
    const response = await axiosInstance.post(API_URL, overrideData)
    return response.data
  } catch (error) {
    console.error("Error creating batch override", {
      error: error.response?.data,
      requestData: overrideData,
    })
    throw error
  }
}

export const updateBatchOverride = async (overrideId, overrideData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${overrideId}`, overrideData)
    return response.data
  } catch (error) {
    console.error("Error updating batch override", error)
    throw error
  }
}

export const deleteBatchOverride = async (overrideId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${overrideId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting batch override", error)
    throw error
  }
}

export const getBatchOverrideById = async (overrideId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${overrideId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching batch override details", error)
    throw error
  }
}
